import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./authSlice";
import initSlice from "./initializeSlice";

const store = configureStore({
  reducer: {
    auth: authSlice,
    init: initSlice,
  },
});

export default store;
